import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import NotFoundPage from './pages/404';
import { PAGE_ROUTES, PATHS } from './shared/defines';
import OrderCompletePage from './pages/order-complete';

const AppRoutes: React.FC = () => {
  const partyOrderCompleteRoute = PAGE_ROUTES.find(
    (route) => route.path === PATHS.PARTY_ORDER_COMPLETE
  );

  //another filter to remove the order complete route from PAGE_ROUTES
  const restRoutes = PAGE_ROUTES.filter(
    (route) => route.path !== PATHS.PARTY_ORDER_COMPLETE
  );

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path="/" element={<Navigate to={PATHS.SIGN} />} />
        <Route path={`/${PATHS.READY}`} element={<Navigate to={`/${PATHS.PARTY_ORDER_COMPLETE}`} />} />
        <Route
          path="/thanks"
          element={<Navigate to={PATHS.PARTY_ORDER_COMPLETE} />}
        />
        {partyOrderCompleteRoute && (
          <Route
            key={partyOrderCompleteRoute.path}
            path={partyOrderCompleteRoute.path}
            element={
              <OrderCompletePage
                {...partyOrderCompleteRoute}
                includesShareWaiver
              />
            }
          />
        )}
        {restRoutes.map(({ Component, ...props }) => (
          <Route
            key={props.path}
            path={props.path}
            element={<Component {...props} />}
          />
        ))}
      </Route>
      <Route path="404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to={'/404'} replace={true} />} />
    </Routes>
  );
};
export default AppRoutes;
